export const IconArrowRight = ({
	scheme,
	width,
	height,
	sx,
}: {
	width?: string;
	height?: string;
	scheme?: "light" | "dark";
	sx?: React.CSSProperties;
}) => {
	const color = !scheme || scheme === "light" ? "#1C2E45" : "#FFFFFF";

	return (
		<svg
			width={!width ? "7" : width}
			height={height ? height : "10"}
			viewBox="0 0 7 10"
			style={sx}
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 10H2L7 5L2 0H0L5 5L0 10Z"
				fill={color}
				fillOpacity="0.6"
			/>
		</svg>
	);
};
